/** @format */

// import { useEffect } from "react";
import { motion } from 'framer-motion';
// import { stateLogger } from "../../utils/stateLogger";
import Backdrop from '../backdrop/backdrop.component';
import MessageStatusModal from './modal_message_status';
import StatusModal from './modal_status';
import AccCreationStatusModal from './modal_acc_creation_status';
import PulseLoader from 'react-spinners/PulseLoader';
import './modal.styles.css';

const dropIn = {
  hidden: {
    y: '-100vh',
    opacity: 0,
  },
  visible: {
    y: '0',
    opacity: 1,
    transition: {
      duration: 0.1,
      type: 'spring',
      damping: 25,
      stiffness: 500,
    },
  },
  exit: {
    y: '100vh',
    opacity: 0,
  },
};

const flip = {
  hidden: {
    transform: 'scale(0) rotateX(-360deg)',
    opacity: 0,
    transition: {
      delay: 0.3,
    },
  },
  visible: {
    transform: ' scale(1) rotateX(0deg)',
    opacity: 1,
    transition: {
      duration: 0.5,
    },
  },
  exit: {
    transform: 'scale(0) rotateX(360deg)',
    opacity: 0,
    transition: {
      duration: 0.5,
    },
  },
};

const newspaper = {
  hidden: {
    transform: 'scale(0) rotate(720deg)',
    opacity: 0,
    transition: {
      delay: 0.3,
    },
  },
  visible: {
    transform: ' scale(1) rotate(0deg)',
    opacity: 1,
    transition: {
      duration: 0.5,
    },
  },
  exit: {
    transform: 'scale(0) rotate(-720deg)',
    opacity: 0,
    transition: {
      duration: 0.3,
    },
  },
};

const badSuspension = {
  hidden: {
    y: '-100vh',
    opacity: 0,
    transform: 'scale(0) rotateX(-360deg)',
  },
  visible: {
    y: '-25vh',
    opacity: 1,
    transition: {
      duration: 0.2,
      type: 'spring',
      damping: 15,
      stiffness: 500,
    },
  },
  exit: {
    y: '-100vh',
    opacity: 0,
  },
};

const gifYouUp = {
  hidden: {
    opacity: 0,
    scale: 0,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.2,
      ease: 'easeIn',
    },
  },
  exit: {
    opacity: 0,
    scale: 0,
    transition: {
      duration: 0.15,
      ease: 'easeOut',
    },
  },
};

const Modal = ({
  handleClose,
  text,
  type,
  variant,
  data,
  messageType,
  handleSend,
  loading,
}) => {
  // Log state
  //   useEffect(() => {
  //     stateLogger("Modal", true);
  //     return () => stateLogger("Modal", false);
  //   }, []);

  return (
    <Backdrop onClick={handleClose}>
      {type === 'dropIn' && variant === 'messageStatus' && (
        <motion.div
          onClick={(e) => e.stopPropagation()} // Prevent click from closing modal
          className="modal orange-gradient"
          variants={dropIn}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <ModalText text={text} />
          <MessageStatusModal data={data} />
          <ModalButton onClick={handleClose} label="Close" />
        </motion.div>
      )}

      {type === 'dropIn' && variant === 'accCreationStatus' && (
        <motion.div
          onClick={(e) => e.stopPropagation()} // Prevent click from closing modal
          className="modal orange-gradient"
          variants={dropIn}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <ModalText text={text} />
          <AccCreationStatusModal data={data} />
          <ModalButton onClick={handleClose} label="Close" />
        </motion.div>
      )}
      {type === 'dropIn' && variant === 'statusGeneric' && (
        <motion.div
          onClick={(e) => e.stopPropagation()} // Prevent click from closing modal
          className="modal orange-gradient"
          variants={dropIn}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <ModalText text={text} />
          <StatusModal data={data} messageType={messageType} />
          <ModalButton onClick={handleClose} label="Close" />
        </motion.div>
      )}
      {type === 'dropIn' && !variant && (
        <motion.div
          onClick={(e) => e.stopPropagation()} // Prevent click from closing modal
          className="modal orange-gradient"
          variants={dropIn}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <ModalText text={text} />
          <ModalButton onClick={handleClose} label="Close" />
        </motion.div>
      )}
      {type === 'dropIn' && variant === 'loadingModal' && (
        <motion.div
          onClick={(e) => e.stopPropagation()} // Prevent click from closing modal
          className="modal orange-gradient"
          variants={dropIn}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <ModalText text={text} />
          <div style={{ marginBottom: '30px', zIndex: '5' }}>
            <PulseLoader color="pink" loading={loading} size={10} />
          </div>

          <ModalButton onClick={handleClose} label="Close" />
        </motion.div>
      )}

      {type === 'flip' && !variant && (
        <motion.div
          onClick={(e) => e.stopPropagation()}
          className="modal  orange-gradient"
          variants={flip}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <ModalText text={text} />
          <ModalButton onClick={handleClose} label="Close" />
        </motion.div>
      )}

      {type === 'flip' && variant === 'messageWarning' && (
        <motion.div
          onClick={(e) => e.stopPropagation()}
          className="modal  orange-gradient"
          variants={flip}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <ModalText text={text} />
          <WarningModalSubText data={data} />
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-around',
            }}
          >
            <ModalButton
              onClick={() => {
                handleSend();
                handleClose();
              }}
              label="Yes"
            />
            <ModalButton onClick={handleClose} label="No" />
          </div>
        </motion.div>
      )}

      {type === 'newspaper' && (
        <motion.div
          onClick={(e) => e.stopPropagation()}
          className="modal orange-gradient"
          variants={newspaper}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <ModalText text={text} />
          <ModalButton onClick={handleClose} label="Close" />
        </motion.div>
      )}

      {type === 'badSuspension' && (
        <motion.div
          onClick={(e) => e.stopPropagation()}
          className="modal orange-gradient"
          variants={badSuspension}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <ModalText text={text} />

          <ModalButton onClick={handleClose} label="Close" />
        </motion.div>
      )}

      {type === 'gifYouUp' && (
        <motion.div
          className="modal"
          onClick={(e) => e.stopPropagation()}
          style={{
            padding: 0,
            height: 'auto',
            width: 'auto',
            display: 'flex',
            justifyContent: 'center',
          }}
          variants={gifYouUp}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <h3
            style={{
              color: '#ffaa00',
              textTransform: 'none',
              fontWeight: 400,
              margin: 'auto auto auto 0',
              fontFamily: 'Montserrat',
              fontSize: '150%',
            }}
          >
            Tap x2 to close
          </h3>
          <motion.img
            alt=""
            onDoubleClick={handleClose}
            drag
            // src="https://i.giphy.com/media/O5ac76MtFGPHG/giphy.gif"
            // src="https://i.giphy.com/media/jmS6YojdAaYw5z1LHi/giphy.gif"
            src="https://i.giphy.com/media/hhgAbqQpm49vW/giphy.gif"
            style={{
              margin: '0 auto auto auto',
              maxHeight: '40vh',
              height: '40vh',
              width: 'auto',
              objectFit: 'cover',
              borderRadius: '6px',
              zIndex: 1000,
            }}
          />
        </motion.div>
      )}
    </Backdrop>
  );
};

const ModalText = ({ text }) => (
  <div className="modal-text">
    <h3>{text}</h3>
  </div>
);

const WarningModalSubText = ({ data }) => (
  <div className="modal-subtext">
    <h6>
      {' '}
      This <span style={{ color: 'white' }}>{`${data.type} `}</span> uses
      <span style={{ color: 'white' }}>{` ${data.template} `}</span> template
      {` and being sent for flight`}
      <span style={{ color: 'white' }}>{` ${data.flights[0]} `}</span>
      {data.flights.length >= 2 ? 'and' : null}
      {data.flights.length >= 2 ? (
        <span style={{ color: 'white' }}>{` ${data.flights[1]} `}</span>
      ) : null}
      {data.flights.length > 2 ? 'and ... ' : ''}
      {data.flights.length > 2 ? (
        <span style={{ color: 'white' }}>{`${data.flights.length - 2}  `}</span>
      ) : null}
      {data.flights.length > 2 ? ' more flights. ' : null}
      {/* {data.template === 'Custom Message' ? (
        <span>Please Note: Custom messages cannot have dynamic data</span>
      ) : null} */}
    </h6>
  </div>
);

const ModalButton = ({ onClick, label }) => (
  <motion.button
    className="modal-button"
    type="button"
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.95 }}
    onClick={onClick}
    style={{ backgroundPosition: 'right center' }}
  >
    {label}
  </motion.button>
);

export default Modal;
